import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  color: var(--primary);
  background-color: var(--secondary);

  @media (max-width: 600px) {
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 1200px) {
  }
`;

export const ContainerOptions = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  min-height: 50vh;
  width: 100%;
  color: var(--primary);
  background-color: var(--secondary);

  div{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 1rem;
    width: 40%;
    min-height: 7rem;
    height: 7rem;
    padding: 1rem 3rem;
    border-radius: 2rem;
    color: var(--secondary);
    background-color: var(--darkBlue);
    cursor: pointer;
  }

  @media (max-width: 600px) {
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 1200px) {
  }
`;

export const ListContent = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction:column;
  align-items:center;
  justify-content:center;
  flex-wrap:nowrap;
  width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 1rem;
  gap: 1rem;
`;

export const Item = styled.div`
  display: flex;
  width: 90%;
  padding: 1rem;
  border: solid 1px var(--primary);
`;

export const Meetings = styled.div`
  display: flex;
  align-items:center;
  justify-content:flex-start;
  flex-wrap:nowrap;
  flex-direction:row;
  width: 100%;
  margin: 0;
  padding: 0.1rem;
`;

export const MeetText = styled.div`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-wrap:nowrap;
  flex-direction:row;
  width: 17%;
  margin: 0;
  padding: 0;
`;

export const MeetList = styled.div`
  display: flex;
  align-items:center;
  justify-content:flex-start;
  flex-wrap:wrap;
  flex-direction:row;
  width: 83%;
  margin: 0;
  padding: 0;
`;

export const Meet = styled.span`
  display: flex;
  align-items:center;
  justify-content:center;
  flex-direction:row;
  width: 15rem;
  margin: 0.5rem;
  padding: 0rem;
  border-radius: 0.5rem;
  background-color: var(--gray);
`;

export const Certificate = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  align-items:center;
  justify-content:space-between;
  flex-direction:row;
  width: 90%;
  margin: 1rem 0 0 0;
  padding: 1rem;
  border: 1px solid var(--primary);
  border-radius: ${(props) => props.roundborder ? css`10rem` : css`0rem`};
  background-color: ${(props) =>
    props.selected ? css`var(--darkBlue)` : css`var(--secondary)`};
  color: ${(props) =>
    props.selected ? css`var(--secondary)` : css`var(--primary)`};
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  div {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    button{
      width: 10rem;
    }
  }
`;

export const Voltar = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 3rem;
  background-color: var(--darkBlue);
  color: var(--secondary);
  cursor: pointer;
`;

export const ImgAtencao = styled.img`
width: 15rem;
`

export const Alert = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction:column;
  align-items:center;
  justify-content:center;
  flex-wrap:nowrap;
  width: 100%;
  min-height: 40vh;
  margin: 0;
  padding: 0;
  border-radius: 1rem;
  gap: 1rem;
  div {
    border-radius: 3rem;
    padding: 1rem;
    background-color: var(--darkBlue);
    color: var(--secondary);
    cursor: pointer;
  }
`;